var e = /* @__PURE__ */ ((r) => (r.UP = "up", r.DOWN = "down", r))(e || {});
export {
  e as DIRECTION
};
